module.exports = __webpack_public_path__ + "static/cal-start-sip-icon-2fe76ece2229474083e4313f164beddf.svg";